<div>
  <table class="readonly">
    @for (field of readOnlyForm; track field) {
      <tr class="row">
        @if (field.title) {
          <td >
            <h2 class="title">{{ field.title }}</h2>
          </td>
        }
        @if (field.label) {
          <td class="label">{{ field.label }}</td>
        }
        @if (field.value) {
          <td class="value">
            {{ field.value }} {{ field.unitType }}
          </td>
        }
      </tr>
    }
  </table>
</div>
